import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lifeOption: false,
  propertyOption: true,
  token: '', // absolute
  cookie: '', // zetta
  token_vsk: '',
  mortgageBalance: 3000000,
};

export const precalcSlice = createSlice({
  name: 'precalc',
  initialState,
  reducers: {
    setLifeOption: (state, action) => {
        state.lifeOption = action.payload
    },
    setPropertyOption: (state, action) => {
        state.propertyOption = action.payload
    },
    setToken: (state, action) => {
      state.token = action.payload
    },
    setTokenVsk: (state, action) => {
      state.token_vsk = action.payload
    },
    setCookie: (state, action) => {
      state.cookie = action.payload
    },
    setMortgageBalance: (state, action) => {
      state.mortgageBalance = action.payload
    }
  },
});

export const { 
  setTokenVsk, 
  setLifeOption, 
  setPropertyOption,
  setCookie,
  setToken,
  setMortgageBalance,
} = precalcSlice.actions;


export const selectLifeOption = (state) => state.precalc.lifeOption;
export const selectPropertyOption = (state) => state.precalc.propertyOption;
export const selectToken = (state) => state.precalc.token;
export const selectTokenVsk = (state) => state.precalc.token_vsk;
export const selectCookie = (state) => state.precalc.cookie;
export const selectMortgageBalance = (state) => state.precalc.mortgageBalance;

export default precalcSlice.reducer;
